/* Fransk katalog for locale-advisor-plan-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'adv.plan.viewForecast': 'Voir la prévision',
  'adv.plan.forecastTitle': 'Trésorerie avec événements planifiés',
  'adv.plan.forecastIntro': 'Comparez le solde basé sur les chiffres comptabilisés avec le solde après les événements que vous avez saisis.',
  'adv.plan.forecastWithoutEvents': 'Sans événements planifiés',
  'adv.plan.forecastWithEvents': 'Avec événements planifiés',
  'adv.plan.forecastChange': 'Variation en fin d\'année',
  'adv.plan.forecastScope': 'Les événements planifiés modifient uniquement la prévision, pas la comptabilité ni le budget. Le solde s\'arrête à zéro dans la courbe, la variation en fin d\'année peut donc être inférieure à la somme des événements.',
  'adv.plan.showVariance': 'Afficher les écarts',
  'adv.plan.hideVariance': 'Masquer les écarts',
});
